import { AppSyncError } from "../../../core/utils/aws/appsync/AppSyncError.js";

export function findExpectedAppSyncErrorMessage(
	error: unknown,
	expectedErrors: Record<string, string> = {},
): string | undefined {
	if (error instanceof AppSyncError) {
		const [mainError] = error.errors;
		const expectedError = mainError?.errorType && expectedErrors[mainError.errorType];
		if (expectedError) {
			return expectedError;
		}
	}
	return undefined;
}
